/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import ColorButton from '../shared/Buttons/ColorButton'
import { useState } from 'react'
import Body from '../shared/Typography/Body/Body'

import styled from '@emotion/styled'
import { navigate } from 'gatsby'

const Caption = ({ children, ...props }) => (
  <Body variant="caption" sx={{ color: 'body' }} {...props}>
    {children}
  </Body>
)

const GetColorDescription = ({ color }) => {
  if (color === 'rose-gold') {
    return (
      <Caption>
        Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same
        real 14k gold as our solid 14k gold jewelry
      </Caption>
    )
  }
  if (color === 'silver') {
    return (
      <Caption>
        Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same
        real 14k gold as our solid 14k gold jewelry
      </Caption>
    )
  }
  if (color === 'gold-silver') {
    return (
      <Caption>
        Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same
        real 14k gold as our solid 14k gold jewelry
      </Caption>
    )
  }
  if (color === 'silver-gold') {
    return (
      <Caption>
        Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same
        real 14k gold as our solid 14k gold jewelry
      </Caption>
    )
  }
  if (color === 'diamond') {
    return (
      <Caption>
        Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same
        real 14k gold as our solid 14k gold jewelry
      </Caption>
    )
  }
  return (
    <Caption>
      Gold-Bonded chains are pure 925 Sterling Silver coated 3x in the same real
      14k gold as our solid 14k gold jewelry
    </Caption>
  )
}

export const generateVariantLink = (url, newVariant) => {
  return url.replace(
    /black-diamond|silver-gold|gold-silver|gold|silver|diamond|vs-diamond|solid-gold|rose-gold|black|white-gold|$/,
    newVariant
  )
}

const ColorSwatchesWrapper = styled.div`
  flex-direction: row;
  width: 100%;
`

const ColorInfoBlock = props => {
  const [activeColor, setActiveColor] = useState(props['materials'][0])

  return (
    <Flex
      sx={{
        justifyContent: 'flex-start',
        // flexDirection: 'column',
        flexWrap: 'wrap',
        ...props.sx,
      }}
    >
      {props.materials.length > 0 && (
        <Body
          variant="caption"
          sx={{
            fontWeight: 'semiBold',
            mb: '2px',
            ml: '3px',
          }}
        >
          Metal:
        </Body>
      )}

      <Body
        variant="caption"
        sx={{
          textTransform: 'capitalize',
          mb: '2px',
          ml: '3px',
        }}
      >
        {activeColor && activeColor.replace('-', ' ')}
      </Body>

      <ColorSwatchesWrapper>
        {props.materials.map((color, index) => {
          return (
            <ColorButton
              onClick={c => {
                navigate(
                  `/products/${generateVariantLink(props.handle, color)}`
                )
              }}
              isActive={activeColor === color}
              key={index}
              color={color}
            />
          )
        })}
      </ColorSwatchesWrapper>
    </Flex>
  )
}

export default ColorInfoBlock
